import { Command } from 'commander';
import chalk from 'chalk';
import { logger } from '../lib/logger.js';
import { updateCommands, checkInstallation, checkRalphInstallation, installRalphConfig } from '../lib/installer.js';

export const updateCommand = new Command('update')
  .description('Update commands to the latest version')
  .option('-g, --global', 'Update user directory ~/.claude (default)', true)
  .option('-l, --local', 'Update project directory ./.claude')
  .option('-n, --dry-run', 'Preview changes without modifying files')
  .action(async (options) => {
    const dryRun = options.dryRun ?? false;

    if (dryRun) {
      logger.header('SmartStack Update - DRY RUN');
    } else {
      logger.header('Updating SmartStack Commands');
    }

    const isGlobal = !options.local;
    const installation = await checkInstallation({ global: isGlobal });

    if (!installation.installed) {
      logger.warning('No existing installation detected — running full install with force...');
    }

    const spinner = dryRun ? null : logger.spinner('Updating commands...');

    try {
      const result = await updateCommands({
        global: isGlobal,
        dryRun,
      });

      if (spinner) {
        spinner.succeed('Commands updated successfully!');
      }

      // Refresh Ralph config if .ralph/ exists in current project
      const ralphStatus = await checkRalphInstallation();
      if (ralphStatus.installed) {
        if (!dryRun) {
          const ralphResult = await installRalphConfig({ force: true });
          if (ralphResult.success) {
            logger.success('Ralph configuration refreshed');
          }
        } else {
          logger.info(`[DRY RUN] Would refresh ${chalk.cyan('.ralph/ralph.config.yaml')}`);
        }
      }

      // Display summary
      logger.info('');
      logger.info('Update Summary:');
      logger.info(`  Files updated: ${result.updated}`);
      logger.info(`  Files removed: ${result.removed}`);

      if (result.removedFiles.length > 0 && !dryRun) {
        logger.info('');
        logger.info('Removed obsolete files:');
        for (const file of result.removedFiles) {
          logger.warning(`  - ${file}`);
        }
      }

      if (result.errors.length > 0) {
        logger.info('');
        logger.warning(`Errors: ${result.errors.length}`);
        for (const err of result.errors) {
          logger.error(`  ${err}`);
        }
      }

      if (dryRun && result.removed > 0) {
        logger.info('');
        logger.info('Run without --dry-run to apply changes.');
      }
    } catch (error) {
      if (spinner) {
        spinner.fail('Update failed');
      }
      logger.error(error instanceof Error ? error.message : 'Unknown error');
      process.exit(1);
    }
  });
